// extracted by mini-css-extract-plugin
module.exports = {"cardMosaicFaq":"destacattext_cardMosaicFaq__oytDS","titolItem":"destacattext_titolItem__Yq6rF","iconaMosaicCards":"destacattext_iconaMosaicCards__q41S0"};